module.exports = __webpack_public_path__ + "img/share_kakao.90ce004.svg";